import { ValidationUtil } from "../../utils/validation";
import { RouterUtil } from "../../utils/router";
import axios from 'axios';
import { M } from '../../main.js';
import gsap from "gsap";

const contactMixin = {
    data() {
        return {
            LANG_SYSTEM: LANG_SYSTEM,
            LangValidate: LANG_SYSTEM.LangValidate,

            forms: LANG_SYSTEM.FORMS,
            
            prodCost: {
                value: 0,
                ratio: 1,
            },
        
            operatingCost: {
                value: 0,
                ratio: 1,
            },
            
            tax: 1,
            
            isGooglerecaptcha: false,
            googlerecaptcha: null,

            //View
            // input / confirm / thanks
            step: 'input',
            isLock: false,
            debugStyleError: false,
            debugSendToDevMail: '',
            dataLoaded: false,
            
            // アニメーションで表示する値
            animatedProdCostDesignMin: 0,
            animatedProdCostDesignMax: 0,
            animatedProdCostDevelopMin: 0,
            animatedProdCostDevelopMax: 0,
            animatedProdCostTotalMin: 0,
            animatedProdCostTotalMax: 0,
            
            //カンマ付き表示よう
            animatedProdCostDesignMinFormatted: "0",
            animatedProdCostDesignMaxFormatted: "0",
            animatedProdCostDevelopMinFormatted: "0",
            animatedProdCostDevelopMaxFormatted: "0",
            animatedProdCostTotalMinFormatted: "0",
            animatedProdCostTotalMaxFormatted: "0",
        };
    },
    watch: {        
        prodCostDesignMin(newValue) {
            this.animateValue("animatedProdCostDesignMin", newValue);
        },
        prodCostDesignMax(newValue) {
            this.animateValue("animatedProdCostDesignMax", newValue);
        },
        prodCostDevelopMin(newValue) {
            this.animateValue("animatedProdCostDevelopMin", newValue);
        },
        prodCostDevelopMax(newValue) {
            this.animateValue("animatedProdCostDevelopMax", newValue);
        },
        prodCostTotalMin(newValue) {
            this.animateValue("animatedProdCostTotalMin", newValue);
        },
        prodCostTotalMax(newValue) {
            this.animateValue("animatedProdCostTotalMax", newValue);
        },
    },
    computed: {
        
        isWeb() {
            if ( this.isDesign && this.isSelected('1', 'items') ) {
                return true;
            }
            
            if ( this.isDevelop ) {
                return true;
            }
            
            return false
        },
        isEstimate() {            
            if ( this.forms.needs.value.id == '2' ) {
                return true;
            }
            
            return false
        },
        isDesign() {
            if ( this.isSelected('1', 'genre') ) {
                return true;
            }
            
            return false
        },
        isDevelop() {            
            if ( this.isSelected('2', 'genre') ) {
                return true;
            }
            
            return false
        },
        // Webデザイン費用
        prodCostDesignWebMin() {
            const { totalMinCost, totalRatio } = this.calculateCost("prodCost");
            return Math.floor(totalMinCost.designWeb * totalRatio.design * this.tax);
        },
        prodCostDesignWebMax() {
            const { totalMaxCost, totalRatio } = this.calculateCost("prodCost");
            return Math.floor(totalMaxCost.designWeb * totalRatio.design * this.tax);
        },
        
        // グラフィックデザイン費用
        prodCostDesignGraphicMin() {
            const { totalMinCost, totalRatio } = this.calculateCost("prodCost");
            return Math.floor(totalMinCost.designGraphic * totalRatio.design * this.tax);
        },
        prodCostDesignGraphicMax() {
            const { totalMaxCost, totalRatio } = this.calculateCost("prodCost");
            return Math.floor(totalMaxCost.designGraphic * totalRatio.design * this.tax);
        },
        
        // デザイン費用（合算）
        prodCostDesignMin() {
            return this.prodCostDesignWebMin + this.prodCostDesignGraphicMin;
        },
        prodCostDesignMax() {
            return this.prodCostDesignWebMax + this.prodCostDesignGraphicMax;
        },
        
        // 開発費用
        prodCostDevelopMin() {
            const { totalMinCost, totalRatio } = this.calculateCost("prodCost");
            return Math.floor(totalMinCost.develop * totalRatio.develop * this.tax);
        },
        prodCostDevelopMax() {
            const { totalMaxCost, totalRatio } = this.calculateCost("prodCost");
            return Math.floor(totalMaxCost.develop * totalRatio.develop * this.tax);
        },
        
        // 総合費用
        prodCostTotalMin() {
            return this.prodCostDesignMin + this.prodCostDevelopMin;
        },
        prodCostTotalMax() {
            return this.prodCostDesignMax + this.prodCostDevelopMax;
        },

    },
    methods: {
        onBackToInput(){
            this.step = 'input';
        },
        toConfirm() {
            //console.log('toConfirm');

            const allResultsTrue = this.validateForms(this.forms);
            //console.log('allResultsTrue', allResultsTrue);

            if (allResultsTrue) {
                //console.log('ok');
                this.step = 'confirm';
                RouterUtil.scrollToForm('app');
                
            } else {
                //console.log('dame');
                this.step = 'input';
                RouterUtil.scrollToForm('app');
            }
        },
        async toSend() {
            const allResultsTrue = this.validateForms(this.forms);
        
            if (allResultsTrue) {
                this.isLock = true;
                let sendData = {};
        
                for (let key in this.forms) {
                    if (this.forms.hasOwnProperty(key)) {
        
                        if (this.forms[key].type === 'checkbox') {
                            const data = this.forms[key].value || [];
        
                            if (data.length > 0) {
                                sendData[key] = data.map(item => item.lang.ja.label).join('\n');
                            }
        
                        } else if (this.forms[key].type === 'radio') {
                            sendData[key] = this.forms[key].value.lang.ja.label;
        
                        } else {
                            sendData[key] = this.forms[key].value;
                        }
                    }
                }
        
                sendData.dev = this.debugSendToDevMail;
                sendData.estimate = `デザイン費: ${this.prodCostDesignMin}~${this.prodCostDesignMax}, 開発費: ${this.prodCostDevelopMin}~${this.prodCostDevelopMax}`;
                console.log(sendData);
                console.log(`${import.meta.env.VITE_PROTOCOL}${import.meta.env.VITE_API_BASE_URL}/api/contact.php`);

        
                const formData = new FormData();
        
                for (let key in sendData) {
                    formData.append(key, sendData[key]);
                }
        
                try {
                    const response = await axios.post(
                        `${import.meta.env.VITE_PROTOCOL}${import.meta.env.VITE_API_BASE_URL}/api/contact.php`,
                        formData,
                        {
                            withCredentials: true
                        }
                    );
        
                    console.log('response:', response);
        
                    if (response.data.result === 'success') {
                        this.step = 'thanks';
                        this.isLock = false;
                        RouterUtil.scrollToForm('main');
                    } else {
                        this.runError(response.data.mes);
                        this.step = 'input';
                        this.isLock = false;
                        RouterUtil.scrollToForm('main');
                    }
        
                } catch (error) {
                    this.runError('通信エラーが発生しました。');
                    this.step = 'input';
                    this.isLock = false;
                    RouterUtil.scrollToForm('main');
                }
        
                return true;
            } else {
                this.step = 'input';
                RouterUtil.scrollToForm('main');
            }
        },
  
        async executeRecaptcha() {            
            return new Promise(async (resolve) => {
                grecaptcha.ready(async () => {
                    try {
                        const token = await grecaptcha.execute(M.grecaptchaSiteKey, { action: 'submit' });
                        this.googlerecaptcha = document.getElementById('googlerecaptcha');
                        this.googlerecaptcha.value = token;
                        resolve();
                    } catch (error) {
                        console.log('Recaptcha execution error:', error);
                        this.runError('通信エラーが発生しました。再度時間をおいて送信してください。');
                        this.step = 'input';
                        this.isLock = false;
                        resolve();
                    }
                });
            });
        },
        onInput(key, value) {
            //@ts-ignore
            const form = this.forms[key];
            const type = form.type;
                // return;
    
            if (!form) {
                console.error(`Form with key ${key} not found.`);
                return;
            }
    
            if (type === 'checkbox') {
                // Ensure form.value is initialized to an empty array
                form.value = form.value || [];
    
                //@ts-ignore
                const valueIndex = form.value.indexOf(value);
    
                if (valueIndex === -1) {
                    //@ts-ignore
                    form.value.push(value);
                } else {
                    //@ts-ignore
                    form.value.splice(valueIndex, 1);
                }
                //this.setInitialCheckboxValues();
    
            } else if (type === 'radio') {
                //@ts-ignore
                form.value = value;
            } else {
                //@ts-ignore
                form.value = value;
                //@ts-ignore
                ValidationUtil.validation(form);
            }
            //console.log('onInput:', form);
        },
        addCommasToNumber(number) {
            // 数字を文字列に変換して、逆順にしてから3桁ごとにカンマを挿入
            const reversedNumberString = number.toString().split('').reverse().join('');
            const formattedNumber = reversedNumberString.replace(/(\d{3})/g, '$1,');
    
            // 最後に再度逆順にして、余分なカンマを除去
            return formattedNumber.split('').reverse().join('').replace(/^,/, '');
        },
        validateForms(forms) {
            
            if (!forms) {
                return false;
            }
            
            //console.log(forms);
            for (const key in forms) {
                ValidationUtil.validation(forms[key]);
            }
            
            // オブジェクトのプロパティ値を配列に変換
            const resultsArray = Object.values(forms).map(item => item.result);
            
            // 全ての結果が true かどうかを確認
            return resultsArray.every(result => result === true);
        },        
        setInitialCheckboxValues() {
            for (const key in this.forms) {
                if (Object.prototype.hasOwnProperty.call(this.forms, key)) {
                    const form = this.forms[key];
    
                    if (form.type === 'checkbox' || form.type === 'radio') {
                        form.value = this.getInitialCheckedValues(form);
                    }
                }
            }
        },    
        getInitialCheckedValues(form) {
            if (form.value && form.value.id) {
                console.log('form.value', form.value.id);
                form.format.forEach(item => {
                    item.checked = item.id === form.value.id ? 'checked' : '';
                    //console.log(item);
                });
    
                return form.value;
            }
    
            return form.format
                .filter(item => item.checked === 'checked')
                .map(item => (form.type === 'checkbox' ? item : item))[0];
        },
        hasNeedTalk() {
            // forms内にneedTalkがtrueのものがあるかチェック
            return Object.values(this.forms).some(form => {
                if (Array.isArray(form.value)) {
                    return form.value.some(item => item.needTalk);
                }
                if (typeof form.value === 'object' && form.value !== null) {
                    return form.value.needTalk === true;
                }
                return false;
            });
        },
        calculateCost(costType) {
            let totalMinCost = {
                designWeb: 0,
                designGraphic: 0,
                develop: 0,
            };
            let totalMaxCost = {
                designWeb: 0,
                designGraphic: 0,
                develop: 0,
            };
            let totalRatio = {
                design: 1,
                develop: 1,
            };
                    
            // Webサイトが選択されているかチェック
            const isWebSelected =
                this.forms.items &&
                Array.isArray(this.forms.items.value) &&
                this.forms.items.value.some(item => item.id === '1' || item.id === 1);
                
            const isDevelopSelected =
                this.forms.genre &&
                Array.isArray(this.forms.genre.value) &&
                this.forms.genre.value.some(item => item.id === '2' || item.id === 2);
        
            for (const key in this.forms) {
                if (Object.prototype.hasOwnProperty.call(this.forms, key)) {
                    const form = this.forms[key];
        
                    const processCost = (cost) => {
                        if (cost) {
                            // デザインの個別値を計算
                            if (cost.design) {
                                totalMinCost.designWeb += cost.design.web?.min || 0;
                                totalMaxCost.designWeb += cost.design.web?.max || 0;
                                totalMinCost.designGraphic += cost.design.graphic?.min || 0;
                                totalMaxCost.designGraphic += cost.design.graphic?.max || 0;
                            }
                            // 開発の値を計算
                            if (cost.develop) {
                                totalMinCost.develop += cost.develop.web?.min || 0;
                                totalMaxCost.develop += cost.develop.web?.max || 0;
                            }
                            // 比率を適用
                            if (cost.ratio) {
                                totalRatio.design += cost.ratio.design || 0;
                                totalRatio.develop += cost.ratio.develop || 0;
                            }
                        }
                    };
        
                    if (form.type === "checkbox") {
                        if (Array.isArray(form.value)) {
                            for (const item of form.value) {
                                processCost(item[costType]);
                            }
                        }
                    } else {
                        processCost(form.value[costType]);
                    }
                }
            }
        
            //Webサイトが選択されていない場合、該当する値を0にする
            if (!isWebSelected) {
                totalMinCost.designWeb = 0;
                totalMaxCost.designWeb = 0;
            }
            
            if (!isDevelopSelected) {
                //console.log('isDevelopSelected');
                totalMinCost.develop = 0;
                totalMaxCost.develop = 0;
            }
        
            return { totalMinCost, totalMaxCost, totalRatio };
        },
        animateValue(targetKey, newValue) {
            gsap.to(this, {
                duration: 1, // アニメーションの時間（秒）
                [targetKey]: newValue, // アニメーション対象のキー
                ease: "power2.out", // イージング
                onUpdate: () => {
                    // 小数点以下を切り捨てしてカンマを付ける
                    const roundedValue = Math.floor(this[targetKey]);
                    this[`${targetKey}Formatted`] = new Intl.NumberFormat().format(roundedValue);
                },
            });
        },
        resetDesign() {
            for (const key in this.forms) {
            if (Object.prototype.hasOwnProperty.call(this.forms, key)) {
                const form = this.forms[key];
        
                // 'prodCost' 内の 'design' のみリセット
                if (form.prodCost && form.prodCost.design) {
                form.prodCost.design.web.min = 0;
                form.prodCost.design.web.max = 0;
                form.prodCost.design.graphic.min = 0;
                form.prodCost.design.graphic.max = 0;
                }
            }
            }
        },
        resetDevelop() {
            for (const key in this.forms) {
            if (Object.prototype.hasOwnProperty.call(this.forms, key)) {
                const form = this.forms[key];
        
                // 'prodCost' 内の 'develop' のみリセット
                if (form.prodCost && form.prodCost.develop) {
                form.prodCost.develop.web.min = 0;
                form.prodCost.develop.web.max = 0;
                }
            }
            }
        },
        isSelected(id, formKey) {
            const form = this.forms[formKey];
        
            // form が存在し、value が配列であるかをチェック
            if (form && Array.isArray(form.value)) {
                return form.value.some(item => item.id === id || item.id === parseInt(id));
            }
            return false;
        },
        runError(e) {
            alert(e);
        },
    },
    async mounted() {
        this.setInitialCheckboxValues();
        this.dataLoaded = true;

        this.debugSendToDevMail = RouterUtil.getParentQueryParam('contact');
        
        //console.log('debugSendToDevMail', this.debugSendToDevMail);
        
        if (this.debugStyleError) {
            this.forms.customerName.error = 'empty';
            this.forms.customerEmail.error = 'empty';
            this.forms.customerPhone.error = 'empty';
            this.forms.formBody.error = 'empty';
        }
    }
};

export default contactMixin;